import * as React from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from '@mui/material'
import { useNavigate } from '@tanstack/react-router'
import { useAuth } from '@modules/auth/AuthProvider'
import { PortalBrand } from '@shared/Brand'
import VaktScanSessionPage from './VaktScanSessionPage'

function currentPath(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

export default function VaktChecklistPage() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const hasScanSession = new URLSearchParams(window.location.search).has('scan_session')

  React.useEffect(() => {
    if (user) return
    navigate({ to: '/login', search: { next: currentPath() }, replace: true })
  }, [navigate, user])

  if (hasScanSession) return <VaktScanSessionPage />

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Container maxWidth="sm" sx={{ py: { xs: 3, sm: 6 } }}>
        <Paper variant="outlined" sx={{ p: { xs: 2.5, sm: 4 } }}>
          <Stack spacing={3}>
            <PortalBrand center stacked />
            <Stack spacing={2} alignItems="center" textAlign="center">
              <CheckCircleIcon color="success" sx={{ fontSize: 44 }} />
              <Stack spacing={0.5}>
                <Typography variant="h6" component="h1" sx={{ fontWeight: 700 }}>
                  Vakt koblet
                </Typography>
                <Typography color="text.secondary">
                  Du kan fortsette når vaktflaten er klar.
                </Typography>
              </Stack>
              <Button href="/" variant="contained">
                Til portal
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    </Box>
  )
}
